import * as React from "react";
function SvgEmoji(
  props: React.SVGProps<SVGSVGElement>,
  svgRef?: React.Ref<SVGSVGElement>
) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 48 48"
      ref={svgRef}
      {...props}
    >
      <path d="M41.2 7.3C32-2.2 16.8-2.4 7.3 6.7s-9.8 24.5-.5 34 24.4 9.8 33.9.5c4-3.9 6.5-9.2 7.1-14.7.8-7.1-1.6-14.1-6.6-19.2zm4.4 18.9c-1.2 11.9-11.8 20.6-23.7 19.4C10 44.4 1.4 33.8 2.6 21.9S14.3 1.5 26.2 2.5c5 .6 9.8 2.9 13.3 6.4 4.4 4.7 6.7 11 6.1 17.3zM17.3 15.3c1.4 0 2.6 1.3 2.6 3s-1.2 3-2.6 3-2.6-1.3-2.6-3 1.2-3 2.6-3zm16.3 12.1c-3.1 1-6.4 1.5-9.6 1.7-3.3 0-6.7-.6-9.8-1.7-.6-.2-1.3.1-1.5.7 0 .1-.1.2-.1.5 0 6.2 5.1 11.3 11.3 11.3s11.3-5.1 11.3-11.3c0-.7-.6-1.2-1.2-1.2-.2-.1-.3 0-.4 0zm-9.8 10c-4.3 0-8-3.1-8.8-7.3 3 .8 5.9 1.3 9 1.3 2.9-.1 5.8-.6 8.6-1.3-.7 4.3-4.4 7.4-8.8 7.3zm11.3-17.5c0-2-1.5-3.6-3.6-3.6S28 17.9 28 19.9c1.2-.4 2.4-.5 3.6-.6 1.2 0 2.3.2 3.5.6z" />
    </svg>
  );
}
const ForwardRef = React.forwardRef(SvgEmoji);
const MemoForwardRef = React.memo(ForwardRef);
export default MemoForwardRef;
